import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

@Component({
  selector: 'atx-stepper-indicators',
  templateUrl: './stepper-indicators.component.html',
  styleUrls: ['./stepper-indicators.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AtxStepperIndicators {
  @Input()
  public steps: unknown[];

  @Input()
  public currentIndex = 0;

  @Output()
  public indicatorChanged = new EventEmitter<number>();
}
